import httpClient from "@plugins/http";

const fetchWhiteList = () => {
  return httpClient.get("/apis/configuration/htmlWhitelist");
};

export default {
  fetchWhiteList,
};
